import React from 'react';
import {createContext, useEffect, useContext, useReducer} from 'react';

// https://medium.com/simply/state-management-with-react-hooks-and-context-api-at-10-lines-of-code-baf6be8302c
// const getExhibitionData = window.getExhibitionData;

const reducer = (state, action) => {
  switch (action.type) {
    case 'pageTransitionStart':
      return {
        ...state,
        pageTransition: true,
        menuIsActive: false
      }
    case 'pageTransitionEnd':
      return {
        ...state,
        pageTransition: false
      }
    case 'toggleActiveContent':
      return {
        ...state,
        // pageTransition: false,
        currentActiveContent: (state.currentActiveContent + 1) % 2
      };
    case 'setCurrentActiveContent':
      return {
        ...state,
        currentActiveContent: action.data
      };
    case 'setMenuIsActive':
      return {
        ...state,
        menuIsActive: action.data
      };
    case 'setCurrentLanguage':
      return {
        ...state,
        currentLanguage: action.data
      };
    case 'setCurrentPage':
      return {
        ...state,
        currentPage: action.data
      };
        
    case 'setCurrentEvent':
      return {
        ...state,
        currentEvent: action.data
      };
    case 'init':
      // setAppData(action.data);
      return {
        ...state,
        appData: action.data
      };
    default:
      return {
        currentActiveContent: 0,
        menuIsActive: false
      };
      //'appData';
  }
}

const DataContext = createContext();
const DataProvider = ({initialState, children}) => {
  const reducerValue = useReducer(reducer, initialState);
  const [ , dispatch] = reducerValue;

  useEffect(() => {
    dispatch({
      type: 'setCurrentActiveContent',
      data: 0
    });
    if (window.__PRELOADED_STATE__) {
      // init the context here?
      delete window.__PRELOADED_STATE__;
    }
    // getExhibitionData('./scripts/data.json', (data) => {
    //   const dataJson = JSON.parse(data);
    //   // dunno how to initialize the context in App.js
    //   // const [ , dispatch] = reducerValue;
    //   dispatch({
    //     type: 'init',
    //     data: dataJson['exhibition']
    //   })
    // });
  }, [dispatch]);
  
  // return <DataContext.Provider value={{appData: appData, reducer: reducer}}>
  return <DataContext.Provider value={reducerValue}>
    {children}
  </DataContext.Provider>;
}
const useDataValue = () => useContext(DataContext);

export {
  DataContext,
  DataProvider,
  useDataValue
}